"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useAsyncCall = function (call) {
    var _a = react_1.useState(null), error = _a[0], setError = _a[1];
    var _b = react_1.useState(false), loading = _b[0], setLoading = _b[1];
    var asyncCall = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setLoading(true);
                        return [4, call.apply(void 0, args)];
                    case 1:
                        _a.sent();
                        return [3, 4];
                    case 2:
                        error_1 = _a.sent();
                        setError(error_1);
                        return [3, 4];
                    case 3:
                        setLoading(false);
                        return [7];
                    case 4: return [2];
                }
            });
        });
    };
    return [asyncCall, loading, error];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWFzeW5jLWNhbGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlLWFzeW5jLWNhbGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQkFBK0I7QUFLbEIsUUFBQSxZQUFZLEdBQUcsVUFBc0IsSUFBTztJQUMvQyxJQUFBLDJCQUFrQyxFQUFqQyxhQUFLLEVBQUUsZ0JBQTBCLENBQUM7SUFDbkMsSUFBQSw0QkFBdUMsRUFBdEMsZUFBTyxFQUFFLGtCQUE2QixDQUFDO0lBRTlDLElBQU0sU0FBUyxHQUFHO1FBQU8sY0FBYzthQUFkLFVBQWMsRUFBZCxxQkFBYyxFQUFkLElBQWM7WUFBZCx5QkFBYzs7Ozs7Ozs7d0JBRS9CLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQzt3QkFDakIsV0FBTSxJQUFJLGVBQUksSUFBSSxHQUFDOzt3QkFBbkIsU0FBbUIsQ0FBQzs7Ozt3QkFFcEIsUUFBUSxDQUFDLE9BQUssQ0FBQyxDQUFDOzs7d0JBRWhCLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQzs7Ozs7O0tBRXpCLENBQUM7SUFFRixPQUFPLENBQUMsU0FBYyxFQUFFLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQztBQUM1QyxDQUFDLENBQUMifQ==